import React from 'react';
import MultipleChoice from './MultipleChoice';
import CarePlan from './CarePlan';
import Calculation from './Calculation';
import DrugChoice from './DrugChoice';
import MultipleAnswer from './MultipleAnswer';
import WorkthroughTask from './WorkthroughTask';
import ChartReview from './ChartReview';
import ChartAnnotation from './ChartAnnotation';
import InterventionNote from './InterventionNote';
import DischargeLetter from './DischargeLetter';
import PrescriptionAddition from './PrescriptionAddition';
import RiskAssess from './RiskAssess';
import PrescriptionEdit from './PrescriptionEdit';
import WitnessSignOff from './WitnessSignOff';

const QuestionContainer = ({ questions = [], drugLibrary, prescriptions = [] }) => {
  return questions.map((question, index) => {
    const key = question.questionNumber || index;
    switch (question.questionType) {
      case 'MultipleChoice':
        return <MultipleChoice key={key} question={question} />;
      case 'Calculation':
        return <Calculation key={key} question={question} />;
      case 'CarePlan':
        return <CarePlan key={key} question={question} />;
      case 'DrugChoice':
        return <DrugChoice key={key} question={question} drugLibrary={drugLibrary} />;
      case 'MultipleAnswer':
        return <MultipleAnswer key={key} question={question} />;
      case 'WorkthroughTask':
        return <WorkthroughTask key={key} question={question} />;
      case 'ChartReview':
        return <ChartReview key={key} question={question} prescriptions={prescriptions} />;
      case 'ChartAnnotation':
        return <ChartAnnotation key={key} question={question} prescriptions={prescriptions} />;
      case 'InterventionNote':
        return <InterventionNote key={key} question={question} />;
      case 'DischargeLetter':
        return <DischargeLetter key={key} question={question} />;
      case 'PrescriptionAddition':
        return <PrescriptionAddition key={key} question={question} />;
      case 'RiskAssess':
        return <RiskAssess key={key} question={question} />;
      case 'PrescriptionEdit':
        return <PrescriptionEdit key={key} question={question} prescriptions={prescriptions} />;
      case 'WitnessSignOff':
        return <WitnessSignOff key={key} question={question} />;
      default:
        return null;
    }
  });
};

export default QuestionContainer;
